import { render, staticRenderFns } from "./ProcessedDocumentDetailModal.vue?vue&type=template&id=87746c44"
import script from "./ProcessedDocumentDetailModal.vue?vue&type=script&lang=ts"
export * from "./ProcessedDocumentDetailModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports